import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    GridContainer,
    GridItem3xs4,
    GridItem3xs6,
    GridItem6xs9,
    GridItem6sm12xs12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import { 
    TextValidatorNumber,
    TextValidatorNumberRequired,
    TextValidatorValor,
} from '../../../business-components/TextValidator/TextValidator'

//import { 
//    TextFieldTextSelect,
//} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

//import tipoIRList from '../../../business-rules/List/tipoIRList'

import {
    dadosCompletosConjuge,
    tituloCliente,
    tituloConjuge,
    calculaIdadesDataSimulacao,
} from '../cliente-form/ClienteService'

import {
    IdadeClienteDisabled,
    IdadeDataSimulacaoCliente,
    IdadeVaiAposentarCliente,
    IdadeInicioInssCliente,
    IdadeExpectativaVidaCliente,
    IdadeSimulacaoMorteCliente,
    AlterarIdadesAutomaticasCliente,
    IdadeConjuge,
    IdadeDataSimulacaoConjuge,
    IdadeVaiAposentarConjuge,
    IdadeExpectativaVidaConjuge,
    AlterarIdadesAutomaticasConjuge,
} from './EstudoCompClienteConjuge'

import {
    processaValoresDefaultIniciaisClienteConjuge,
    processaAlteracaoClienteConjugePercRespCliente,
} from './EstudoServiceClienteConjuge'



const EstudoFormClienteConjuge = ({ values, handleChange, handleSubmit }) => {

    processaValoresDefaultIniciaisClienteConjuge(values)

    calculaIdadesDataSimulacao(values, false)

    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer>
                <GridItem6sm12xs12>
                    <CardGridEntradaDados>
                        <CardGridDivHeaderEntradaDados>
                            <CardGridDivEntradaDados>
                                {tituloCliente(values)}
                            </CardGridDivEntradaDados>
                        </CardGridDivHeaderEntradaDados>

                        <CardGridDivBody>
                            <GridContainer>
                                <GridItem3xs4>
                                    <IdadeClienteDisabled
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem3xs4>
                                <GridItem3xs4>
                                    <IdadeVaiAposentarCliente
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem3xs4>
                                <GridItem3xs4>
                                    <IdadeInicioInssCliente
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem3xs4>
                            </GridContainer>
                            
                            <GridContainer>
                                <GridItem3xs4>
                                    <IdadeDataSimulacaoCliente
                                        values={values}
                                        handleChange={handleChange}
                                    /> 
                                </GridItem3xs4>
                                <GridItem3xs4>
                                    <IdadeExpectativaVidaCliente
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem3xs4>
                                {values.exibirMorteAte && (
                                    <GridItem3xs4>
                                        <IdadeSimulacaoMorteCliente
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem3xs4>
                                )}
                            </GridContainer>
                            
                            <GridContainer>
                                <GridItem3xs4>
                                    <TextValidatorValor
                                        name="receitaMensalCliente"
                                        label={LABEL.receitaMensal}
                                        value={values.receitaMensalCliente || ''}
                                        onChange={handleChange}
                                        disabled={true}
                                    />
                                </GridItem3xs4>
                                <GridItem3xs4>
                                    <TextValidatorNumberRequired
                                        name="percRespCliente"
                                        label={LABEL.percResp}
                                        value={values.percRespCliente === 0 ? 0 : values.percRespCliente || ''}
                                        onChange={handleChange}
                                        numMin={NUMMIN.perc}
                                        numMax={NUMMAX.perc}
                                        onBlur={processaAlteracaoClienteConjugePercRespCliente(values)}
                                        disabled={!values.alterarPercRespAutomaticoCliente}
                                    />
                                </GridItem3xs4>
                                {/*
                                <GridItem3xs6>
                                    <TextFieldTextSelect
                                        name="tipoIRCliente"
                                        label={LABEL.tipoIR}
                                        value={values.tipoIRCliente || ''}
                                        onChange={handleChange}
                                        list={tipoIRList}
                                    />
                                </GridItem3xs6>
                                */}
                            </GridContainer>

                            <GridContainer>
                                <GridItem6xs9>
                                    <AlterarIdadesAutomaticasCliente
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem6xs9>
                                <GridItem6xs9>
                                    <CheckboxPadrao
                                        name="alterarPercRespAutomaticoCliente"
                                        label={LABEL.alterarPercRespAutomatico}
                                        checked={values.alterarPercRespAutomaticoCliente}
                                        onChange={handleChange}
                                    />
                                </GridItem6xs9>
                            </GridContainer>
                        </CardGridDivBody>
                    </CardGridEntradaDados>
                </GridItem6sm12xs12>

                <GridItem6sm12xs12
                    style={{
                        display:
                            dadosCompletosConjuge(values) 
                                ? "block"
                                : "none"
                    }}
                >
                    <CardGridEntradaDados>
                        <CardGridDivHeaderEntradaDados>
                            <CardGridDivEntradaDados>
                                {tituloConjuge(values)}
                            </CardGridDivEntradaDados>
                        </CardGridDivHeaderEntradaDados>

                        <CardGridDivBody>
                            <GridContainer>
                                <GridItem3xs4>
                                    <IdadeConjuge
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem3xs4>
                                <GridItem3xs4>
                                    <IdadeVaiAposentarConjuge
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem3xs4>
                                <GridItem3xs4>
                                    <TextValidatorNumberRequired
                                        name="idadeInicioInssConjuge"
                                        label={LABEL.idadeInicioInss}
                                        value={values.idadeInicioInssConjuge === 0 ? 0 : values.idadeInicioInssConjuge || ''}
                                        onChange={handleChange}
                                        numMin={NUMMIN.idade}
                                        numMax={NUMMAX.idade}
                                        disabled={!values.alterarIdadesAutomaticasConjuge}
                                    />
                                </GridItem3xs4>
                            </GridContainer>

                            <GridContainer>
                                <GridItem3xs4>
                                    <IdadeDataSimulacaoConjuge
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem3xs4>
                                <GridItem3xs4>
                                    <IdadeExpectativaVidaConjuge
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem3xs4>
                                {values.exibirMorteAte && (
                                    <GridItem3xs4>
                                        <TextValidatorNumberRequired
                                            name="idadeSimulacaoMorteConjuge"
                                            label={LABEL.idadeSimulacaoMorte}
                                            value={values.idadeSimulacaoMorteConjuge === 0 ? 0 : values.idadeSimulacaoMorteConjuge || ''}
                                            onChange={handleChange}
                                            numMin={NUMMIN.idade}
                                            numMax={NUMMAX.idade}
                                            disabled={true}
                                        />
                                    </GridItem3xs4>
                                )}
                            </GridContainer>

                            <GridContainer>
                                <GridItem3xs4>
                                    <TextValidatorValor
                                        name="receitaMensalConjuge"
                                        label={LABEL.receitaMensal}
                                        value={values.receitaMensalConjuge || ''}
                                        onChange={handleChange}
                                        disabled={true}
                                    />
                                </GridItem3xs4>
                                <GridItem3xs4>
                                    <TextValidatorNumber
                                        name="percRespConjuge"
                                        label={LABEL.percResp}
                                        value={values.percRespConjuge === 0 ? 0 : values.percRespConjuge || ''}
                                        onChange={handleChange}
                                        numMin={NUMMIN.perc}
                                        numMax={NUMMAX.perc}
                                        disabled={true}
                                    />
                                </GridItem3xs4>
                                {/*
                                <GridItem3xs6>
                                    <TextFieldTextSelect
                                        name="tipoIRConjuge"
                                        label={LABEL.tipoIR}
                                        value={values.tipoIRConjuge || ''}
                                        onChange={handleChange}
                                        list={tipoIRList}
                                    />
                                </GridItem3xs6>
                                */}
                            </GridContainer>

                            <GridContainer>
                                <GridItem3xs6>
                                    <AlterarIdadesAutomaticasConjuge
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem3xs6>
                            </GridContainer>
                        </CardGridDivBody>
                    </CardGridEntradaDados>
                </GridItem6sm12xs12>
            </GridContainer>
        </ValidatorForm>
    )
}

export default EstudoFormClienteConjuge